import request from "@utils/request";

/**
 * @author FJJ
 * @version 1.0
 * @Time 2022.05.26
 *
 **/
const SearchApiService = {
    /**
     * 确认退款
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8043
     * @param data
     */
    updateRefundConfirm(data={}) {
        return request({
            url:  '/service/mg/sale/cancel/refund/confirm',
            method: "POST",
            data
        });
    },
    /**
     * 客戶钱包信息
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8533
     */
    getCustomerBalance(data={}) {
        return request({
            url:  '/service/mg/fin/ddp/wallet/query',
            method: "POST",
            data
        });
    },
    /**
     * 钱包提现
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8536
     */
    cashOut(data={}) {
        return request({
            url:  '/service/mg/fin/ddp/wallet/cash-out',
            method: "POST",
            data
        });
    },
    /**
     * 退款处理 登记
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#6276
     */
    refundDisposeAdd(data={}) {
        return request({
            url:  '/service/mg/sale/claimDemage/refund/dispose',
            method: "POST",
            data
        });
    },
};

export default SearchApiService;
